import React, { useContext, useEffect, useState } from 'react';

import Sheet from './Components/Sheet/Sheet';
import Graph from './Components/Graph/Graph';
import Search from './Components/Graph/Components/Search';
import RangeSetting from './Components/RangeSetting/RangeSetting';

import { getRefrigeratorSensorDetailApi } from '@api/monitoring';
import useAsync from '@util/hooks/useAsync';
import { RefrigeratorSensorStateContext } from '../../index';

import moment from 'moment';
import useTranslation from '@hooks/useTranslation';

const ViewDetail = ({ handleRefresh }) => {
    const t = useTranslation('RefrigeratorSensor');
    const { sensorNum } = useContext(RefrigeratorSensorStateContext);
    const [sensorDetail, setSensorDetail] = useState({
        sensorName: '',
        sensorId: '',
        wardInfo: '',
        lastDate: '',
        sensorItems: [],
    });
    const { promise: getRefrigeratorSensorDetail } = useAsync({
        promise: getRefrigeratorSensorDetailApi,
        resolve: res => setSensorDetail(res),
        reject: err => console.error(err),
    });

    useEffect(() => {
        if (sensorNum) {
            getRefrigeratorSensorDetail({ sensorNum });
        }
    }, [sensorNum]);

    const [date, setDate] = useState(moment().unix());
    const handleDate = selected => {
        setDate(selected);
    };

    return (
        <>
            <Search date={date} onChange={handleDate} />
            <div className="d-flex mb-4">
                <div className="w-30 d-flex flex-column">
                    <h5 className="pnt-txt txt-bold mb-2">{t('Refrigerator temperature management ledger')}</h5>
                    <div className="flx-1">
                        <Sheet data={sensorDetail} />
                    </div>
                </div>
                <div className="w-70 d-flex flex-column ml-3">
                    <h5 className="pnt-txt txt-bold mb-2">{t('Graph')}</h5>
                    <div className="flx-1">
                        <Graph date={date} />
                    </div>
                </div>
            </div>
            <div>
                <h5 className="pnt-txt txt-bold mb-2">{t('Range Setting')}</h5>
                <RangeSetting data={sensorDetail} promise={getRefrigeratorSensorDetail} handleRefresh={handleRefresh} />
            </div>
        </>
    );
};

export default ViewDetail;
